import { getPrice } from './useSearchspringUtils'

const getUnitPerCartonLabel = (unitPerCarton = 1, label) => {
  if (unitPerCarton === 1) return `1 ${label}`
  return `${unitPerCarton} ${label}s`
}

const getRetailPrices = (strArr) => {
  if (!strArr) {
    return 1
  }

  return strArr.split('|').map((item) => item)
}

const getUnitPerCartons = (string, count) => {
  if (!string || !string.includes('|')) {
    return new Array(count).fill(parseFloat(string) || 1)
  }

  return string.split('|').map((item) => parseFloat(item))
}

const getTotalPriceByVariants = (items) => {
  let totalPrice = 0
  items.forEach((variant) => {
    totalPrice += variant.price * variant.quantity * (variant?.metafields?.wholesale?.unitPerCarton || 1)
  })
  return totalPrice
}

const getSelectedVariants = (variants, selectedValues) => {
  const selectedVariants = []
  variants.forEach((variant) => {
    const quantity = selectedValues.find((item) => item[variant.id] !== undefined)[variant.id]
    if (quantity > 0) {
      selectedVariants.push({ ...variant, quantity: parseFloat(quantity) })
    }
  })
  return selectedVariants
}

const getVariantQuantity = (variant, unitByCarton) => {
  const unitPerCarton = unitByCarton || 1

  if (variant.inventory_quantity < unitPerCarton && variant.inventory_management !== '') return 0
  if (variant.inventory_policy === 'continue' || variant.inventory_management === '') return 9999

  return Math.floor(variant.inventory_quantity / unitPerCarton)
}

const getCurrentVariantCompany = (currentVariantsCompany, variant) => {
  if (!currentVariantsCompany) return null
  const current = currentVariantsCompany.find((item) => item.id === variant.id)

  if (!current) {
    return null
  }
  return getPrice(current.price, 'default')
}

export {
  getUnitPerCartonLabel,
  getRetailPrices,
  getUnitPerCartons,
  getTotalPriceByVariants,
  getSelectedVariants,
  getVariantQuantity,
  getCurrentVariantCompany
}
